import { APP_ENV } from './central-api';

export const HOME_ROUTE = '/dashboard';
// export const HOME_ROUTE = '/tara';
// export const HOME_ROUTE = '/integrations';

// visibility of routes based on environment
const routeVisibility = {
  DEV: {
    // Top Level
    '/dashboard': true,
    '/stats': true,
    // W5 — audit-log viewer (owner/team_lead). Sidebar link is role-gated in
    // SidebarTara; the page itself also gates on `audit.view`.
    '/audit-log': true,
    // Per-agency Meta API activity & rate-limit view (owner/team_lead). Sidebar
    // link is role-gated in SidebarTara; the page also gates on
    // `meta_activity.view`.
    '/meta-activity': true,
    // Unified Log Center — hosts the Audit + Meta API tabs. The two routes
    // above redirect here. Sidebar link is role-gated in SidebarTara.
    '/logs': true,
    '/tracking': true,
    '/settings': true,
    '/clients': true,

    // Tara
    '/tara': true,
    '/tara/search': true,

    // Integrations (MCP)
    '/integrations': true,

    // W3 — MCP Control Center (govern AI tool access per brand)
    '/control-center': true,

    // Skills
    '/skills': true,
    '/agents': true,

    // Prompt schedules
    // Hidden: nothing runs scheduled prompts, so the page would only store dead schedules.
    '/prompt-schedules': false,

    // Tracking
    '/tracking/trends': true,
    '/tracking/css': true,
    '/tracking/integration': true,
    '/tracking/autofill': false,
    '/tracking/events': true,

    // Legacy reports (notifications, presentations, prompts, graphs) are off:
    // their pages call central-api endpoints that no longer exist
    // (tara/shops/{slug}/insights*, v2 custom-graphs, custom-prompts,
    // presentations) and the section is no longer in the sidebar. A visit now
    // lands on the 404 page like any other disabled route. Client reports live
    // under /client-reports.
    '/reports': false,
    '/reports/notifications': false,
    '/reports/presentations': false,
    '/reports/prompts': false,
    '/reports/graphs': false,

    //ai-optimizations
    '/ai-optimizations': true,
    '/ai-optimizations/automated': true,
    '/ai-optimizations/manual': true,

    // Recommendations
    '/recommendations': false,

    // Actions
    '/actions': true,
    '/actions/queue': true,
    '/actions/history': true,
    '/actions/rules': true,

    // Settings
    '/settings/general': true,
    '/settings/subscription': true,
    '/settings/profile': true,
    '/settings/api-keys': true,
    '/settings/tara': true,
    '/settings/appearance': false,
    '/settings/payments': false,
    '/settings/shipping': false,
    '/settings/convenienceFee': false,
    '/settings/discounts': false,
    '/settings/notifications': true,
    '/settings/webhooks': false,
    '/settings/marketing': false,
    '/settings/security': false,
    '/settings/communication': true,
    '/settings/brand': true,
    '/settings/team': true,
    // Phase 1 (custom roles) — owner-only DB-backed Roles management page.
    // Visibility here just registers the route; actual access is gated on the
    // `settings.manage_org` capability (sidebar link + page guard).
    '/settings/roles': true,

    // Phase 13 — per-employee Claude Code plugin (MCP) setup page.
    '/my-mcp-setup': true,

    // MCP-client OAuth consent page (TARA_PLUGIN_OAUTH2_PLAN.md WS3). The
    // gateway 302s the browser here; the page handles its own login redirect.
    '/oauth/authorize': true,

    // Phase 13 — Team management lives at the top level. `/settings/team`
    // stays visible as a redirect (see SettingsPage.tsx).
    '/team': true,

    // Payments
    '/settings/payments/connection': true,
    '/settings/payments/options': true,

    // Client-report portal (P3) — agency review/edit/approve surface. DEV
    // first per the portal rollout; the sidebar link is capability-guarded on
    // `portal.reports.review` and ClientReportsPage re-gates access.
    '/client-reports': true,
    // P4 — report branding / KPI targets / per-brand portal settings. Each is
    // additionally capability-guarded (branding.manage / kpis.manage /
    // settings.manage) in the sidebar and re-gated inside ClientReportsPage.
    '/client-reports/targets': true,
    '/client-reports/branding': true,
    '/client-reports/settings': true,
    // Phase-3 client inbox (client-inputs API) — DEV first; the tab + page are
    // additionally APP_ENV-gated (INBOX_ENABLED) so they stay inert until the
    // central-api client-inputs endpoints are promoted past DEV.
    '/client-reports/inbox': true,
  },
  STAGING: {
    // Top Level
    '/dashboard': true,
    '/stats': true,
    // W5 — audit-log viewer (owner/team_lead). Sidebar link is role-gated in
    // SidebarTara; the page itself also gates on `audit.view`.
    '/audit-log': true,
    // Per-agency Meta API activity & rate-limit view (owner/team_lead). Sidebar
    // link is role-gated in SidebarTara; the page also gates on
    // `meta_activity.view`.
    '/meta-activity': true,
    // Unified Log Center — hosts the Audit + Meta API tabs. The two routes
    // above redirect here. Sidebar link is role-gated in SidebarTara.
    '/logs': true,
    '/tracking': true,
    '/settings': true,
    '/clients': true,

    // Tara
    '/tara': true,
    '/tara/search': true,

    // Integrations (MCP)
    '/integrations': true,

    // W3 — MCP Control Center (govern AI tool access per brand)
    '/control-center': true,

    // Skills
    '/skills': true,
    '/agents': true,

    // Prompt schedules
    // Hidden: nothing runs scheduled prompts, so the page would only store dead schedules.
    '/prompt-schedules': false,

    // Tracking
    '/tracking/trends': true,
    '/tracking/css': true,
    '/tracking/integration': true,
    '/tracking/autofill': false,
    '/tracking/events': true,

    // Legacy reports: off, see DEV.
    '/reports': false,
    '/reports/notifications': false,
    '/reports/presentations': false,
    '/reports/prompts': false,
    '/reports/graphs': false,

    //ai-optimizations
    '/ai-optimizations': true,
    '/ai-optimizations/automated': true,
    '/ai-optimizations/manual': true,

    // Recommendations
    '/recommendations': false,

    // Actions
    '/actions': true,
    '/actions/queue': true,
    '/actions/history': true,
    '/actions/rules': true,

    // Settings
    '/settings/general': true,
    '/settings/subscription': true,
    '/settings/profile': true,
    '/settings/api-keys': true,
    '/settings/tara': false,
    '/settings/appearance': false,
    '/settings/payments': false,
    '/settings/shipping': false,
    '/settings/convenienceFee': false,
    '/settings/discounts': false,
    '/settings/notifications': true,
    '/settings/webhooks': false,
    '/settings/marketing': false,
    '/settings/security': false,
    '/settings/communication': true,
    '/settings/brand': true,
    '/settings/team': true,
    // Phase 1 (custom roles) — owner-only DB-backed Roles management page.
    // Visibility here just registers the route; actual access is gated on the
    // `settings.manage_org` capability (sidebar link + page guard).
    '/settings/roles': true,

    // Phase 13 — per-employee Claude Code plugin (MCP) setup page.
    '/my-mcp-setup': true,

    // MCP-client OAuth consent page (TARA_PLUGIN_OAUTH2_PLAN.md WS3). The
    // gateway 302s the browser here; the page handles its own login redirect.
    '/oauth/authorize': true,

    // Phase 13 — Team management lives at the top level. `/settings/team`
    // stays visible as a redirect (see SettingsPage.tsx).
    '/team': true,

    // Payments
    '/settings/payments/connection': true,
    '/settings/payments/options': true,

    // Client-report portal (P3) — enabled 2026-07-23: the central-api
    // reporting/inputs/roster endpoints shipped to staging and live in the
    // 2026-07-23 release, so the DEV-first hold is over.
    '/client-reports': true,
    '/client-reports/targets': true,
    '/client-reports/branding': true,
    '/client-reports/settings': true,
    '/client-reports/inbox': true,
  },
  LIVE: {
    // Top Level
    '/dashboard': true,
    '/stats': true,
    // W5 — audit-log viewer (owner/team_lead). Sidebar link is role-gated in
    // SidebarTara; the page itself also gates on `audit.view`.
    '/audit-log': true,
    // Per-agency Meta API activity & rate-limit view (owner/team_lead). Sidebar
    // link is role-gated in SidebarTara; the page also gates on
    // `meta_activity.view`.
    '/meta-activity': true,
    // Unified Log Center — hosts the Audit + Meta API tabs. The two routes
    // above redirect here. Sidebar link is role-gated in SidebarTara.
    '/logs': true,
    '/tracking': true,
    '/settings': true,
    '/clients': true,

    // Tara
    '/tara': true,
    '/tara/search': true,

    // Integrations (MCP)
    '/integrations': true,

    // W3 — MCP Control Center (govern AI tool access per brand)
    '/control-center': true,

    // Skills
    '/skills': true,
    '/agents': true,

    // Prompt schedules
    // Hidden: nothing runs scheduled prompts, so the page would only store dead schedules.
    '/prompt-schedules': false,

    // Tracking
    '/tracking/trends': true,
    '/tracking/css': true,
    '/tracking/integration': true,
    '/tracking/autofill': false,
    '/tracking/events': true,

    // Legacy reports: off, see DEV.
    '/reports': false,
    '/reports/notifications': false,
    '/reports/presentations': false,
    '/reports/prompts': false,
    '/reports/graphs': false,

    //ai-optimizations
    '/ai-optimizations': true,
    '/ai-optimizations/automated': true,
    '/ai-optimizations/manual': true,

    // Recommendations
    '/recommendations': false,

    // Actions
    '/actions': true,
    '/actions/queue': true,
    '/actions/history': true,
    '/actions/rules': true,

    // Settings
    '/settings/general': true,
    '/settings/subscription': true,
    '/settings/profile': true,
    '/settings/api-keys': true,
    '/settings/tara': false,
    '/settings/appearance': false,
    '/settings/payments': false,
    '/settings/shipping': false,
    '/settings/convenienceFee': false,
    '/settings/discounts': false,
    '/settings/notifications': true,
    '/settings/webhooks': false,
    '/settings/marketing': false,
    '/settings/security': false,
    '/settings/communication': true,
    '/settings/brand': true,
    '/settings/team': true,
    // Phase 1 (custom roles) — owner-only DB-backed Roles management page.
    // Visibility here just registers the route; actual access is gated on the
    // `settings.manage_org` capability (sidebar link + page guard).
    '/settings/roles': true,

    // Phase 13 — per-employee Claude Code plugin (MCP) setup page.
    '/my-mcp-setup': true,

    // MCP-client OAuth consent page (TARA_PLUGIN_OAUTH2_PLAN.md WS3). The
    // gateway 302s the browser here; the page handles its own login redirect.
    '/oauth/authorize': true,

    // Phase 13 — Team management lives at the top level. `/settings/team`
    // stays visible as a redirect (see SettingsPage.tsx).
    '/team': true,

    // Payments
    '/settings/payments/connection': false,
    '/settings/payments/options': false,

    // Client-report portal (P3) — enabled 2026-07-23: the central-api
    // reporting/inputs/roster endpoints shipped to staging and live in the
    // 2026-07-23 release, so the DEV-first hold is over.
    '/client-reports': true,
    '/client-reports/targets': true,
    '/client-reports/branding': true,
    '/client-reports/settings': true,
    '/client-reports/inbox': true,
  },
};

const allRoutes = routeVisibility[APP_ENV];

export { allRoutes, routeVisibility };
